<section class="class-account">
  <div class="class-account__header-info">
    <span class="class-account__header-info__class-title">{{ classInfo?.title }} класс</span>
    <p>
      <span>Всего на счетах: </span> 
      <span class="class-account__header-info__sum-reward"> {{ sumReward }} {{ currencyStr }}</span>
      <span class="class-account__header-info__date"> | {{today|date:'dd.MM.yyyy'}} г.</span>
    </p>
  </div>
  <div class="class-account__content">
    <div class="class-account__content_students">
      <div *ngIf="selectedStudent" class="select-student block">
        <div class="select-student__info">
          <span *ngIf="selectedStudent.student.photo" class="select-student__info_close" (click)="closeStudent()">
            <app-svg-icon
              class="close-icon"
              [src]="closeIcon">
            </app-svg-icon>
          </span>
          <span *ngIf="selectedStudent.student.photo" class="select-student__info_photo" [class.female]="selectedStudent.student.gender === 'f'">
            <img [src]="selectedStudent.student.photo" alt="">
          </span>
          <br *ngIf="selectedStudent.student.photo">
          <span class="select-student__info_title">
            {{ selectedStudent.student.surname }} {{ selectedStudent.student.name }}
          </span>
          <span>
            <small>
              На счету: 
              <font color="#6795c5">
                <b>{{ studentAmount }}</b>
              </font>
              {{ selectStudentCurrency }}
            </small>
          </span>
        </div>
      </div>
      <div class="block">
        <div class="students">
          <ul class="students__list">
            <li *ngFor="let account of sortedStudents; let i = index;" class="students__list_student">
              <div class="students__list_student__info" [class.active]="selectedStudent?.id === account.id" (click)="selectStudent(account)">
                <span class="students__list_student__info_index">
                  {{i + 1}}. 
                </span>
                <span class="students__list_student___info_fullname">
                  {{account.student.surname}} {{account.student.name}}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="class-account__content_bank block">
      <app-account-actions
        [selectedStudent]="selectedStudent"
        [currency]="currency"
        (changeSumReward)="getSumClassReward()"
        (changeStudentReward)="changeStudentReward($event)">
      </app-account-actions>
    </div>
  </div>
</section>
